// extracted by mini-css-extract-plugin
export var bottom = "TalkBox-module--bottom--3a02c";
export var hiddenScrollButton = "TalkBox-module--hiddenScrollButton--a4d41";
export var scrollButton = "TalkBox-module--scrollButton--30ab8";
export var talkBox = "TalkBox-module--talkBox--dbde8";
export var talkInner = "TalkBox-module--talkInner--3fbdd";